<template>
  <!-- モーダルウィンドウ -->
  <div :id="modalId" class="c-modal c-modal--contact">
    <div class="c-modal__bg"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="closeModal">
        <div class="c-icon c-icon--white u-wh14">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <use
              xlink:href="/assets/img/sprite.svg#close"
            />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-modal__title">{{ title }}</div>
        <div class="c-modal__data">{{ body }}</div>
        <div class="c-modal__btns">
          <a class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14" :href=url>
            <p class="c-btn__text">{{ button }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- /モーダルウィンドウ -->
</template>

<script>
export default {
  props: {
    title: String,
    body: String,
    button: String,
    url: String,
    modalId: String,
  },
  methods: {
    showModal: function() {
      if(this.modalId){
        $('#'+this.modalId).addClass('is-active');
      } else {
        $('.c-modal').addClass('is-active');
      }
    },
    closeModal: function() {
      if(this.modalId){
        $('#'+this.modalId).removeClass('is-active');
      } else {
        $('.c-modal').removeClass('is-active');
      }
    }
  }
};
</script>